export const backgroundImageMixin = (url) => `
  background-image: url(${url});
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;
